export const CircleInfo = () => (
  <svg
    fill='none'
    height='34'
    viewBox='0 0 34 34'
    width='34'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.5833 9.91671H18.4166V12.75H15.5833V9.91671ZM15.5833 15.5834H18.4166V24.0834H15.5833V15.5834ZM16.9999 2.83337C9.17992 2.83337 2.83325 9.18004 2.83325 17C2.83325 24.82 9.17992 31.1667 16.9999 31.1667C24.8199 31.1667 31.1666 24.82 31.1666 17C31.1666 9.18004 24.8199 2.83337 16.9999 2.83337ZM16.9999 28.3334C10.7524 28.3334 5.66659 23.2475 5.66659 17C5.66659 10.7525 10.7524 5.66671 16.9999 5.66671C23.2474 5.66671 28.3333 10.7525 28.3333 17C28.3333 23.2475 23.2474 28.3334 16.9999 28.3334Z'
      fill='currentColor'
    />
  </svg>
);
